import React from 'react';
import { Navigate } from 'react-router-dom';
import { ResourceArea, usePermissions } from '../../hooks/usePermissions';

interface RequireAreaProps {
  area: ResourceArea;
  children: React.ReactNode;
}

/**
 * Redirects an Investor login away from a route outside their read-only
 * scope (see usePermissions/permissions.py). Every other role passes
 * through unchanged — the backend is the real enforcement point, this
 * just avoids landing an Investor on a page that would only show 403s.
 */
export const RequireArea: React.FC<RequireAreaProps> = ({ area, children }) => {
  const { canAccessArea } = usePermissions();

  if (!canAccessArea(area)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
